import type { BrandingClientSet } from '@mimecast-ui/branding/data-access';

const UNBRANDED_PAGE_TITLE = 'Mimecast Universal Login';

export function applyBrandingPageTitle(
  doc: Document,
  brandingSet: BrandingClientSet
): void {
  const brandName = brandingSet.brandName?.trim();

  doc.title =
    brandingSet.branded && brandName
      ? `${brandName} - Mimecast`
      : UNBRANDED_PAGE_TITLE;
}
